/* eslint-disable prettier/prettier */
import React, { ReactNode } from 'react';
import styles from '../../styles/components/common/ToolTip.module.css';

interface TooltipProps {
	text: string;
	children: ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
	return (
		<div className={styles.wrapper}>
			{children}
			<span className={styles.tooltip}>{text}</span>
		</div>
	);
};

export default Tooltip;
